<template>
  <v-app id="pxs">
    <Navbar />
    <v-content>
      <router-view />
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import Navbar from "@/components/layouts/Navbar";
import Footer from "./components/layouts/Footer";

export default {
	name: "App",

	components: {
		Footer,
		Navbar
	},

	beforeMount: function () {
		this.$store.dispatch({
			type: 'meta/getMetas'
		});
	},
};
</script>